import { MAILCHIMP_CONTACT_US } from "src/Constants";

async function ContactUs(event) {
    event.stopPropagation();
    window.open(MAILCHIMP_CONTACT_US);
}

export { ContactUs };
